const buildMessageError = (errors) => {
  var messages = '';
  if (errors && errors !== null && typeof errors === 'object') {
    Object.keys(errors).forEach(function (key, index) {
      messages += errors[key];
      if (index !== Object.keys(errors).length - 1) messages += ',<br> ';
    });
    return messages;
  }
  if (errors && errors !== null && typeof errors === 'string') {
    return errors;
  }
  return undefined;
};

export default {
  buildMessageError,
  notification(error) {
    let messageError = '';
    if (error.response) {
      const status = error.response.status;
      if (status === 422) {
        let errors = error.response.data.errors;
        if (errors && errors.length > 0) {
          console.log(errors);
          Object.keys(errors).forEach((err) => {
            messageError += errors[err].join('<br>') + '<br>';
          });
        } else {
          const err = error.response.data.error;
          messageError += err.message;
        }
      } else if (status === 412) {
        messageError = error.response.data.message;
      } else if (status === 401) {
        messageError = window.Vue.$t('errorMessages.c401');
      } else if (status === 404) {
        messageError = window.Vue.$t('errorMessages.c404');
      } else if (status === 429) {
        messageError = messageError = window.Vue.$t('errorMessages.c429');
      } else if (status === 409) {
        messageError = window.Vue.$t('errorMessages.c409');
      } else if (status === 500) {
        messageError = buildMessageError(error.response.data.message) || window.Vue.$t('errorMessages.c500');
      } else {
        messageError = window.Vue.$t('errorMessages.common');
      }
    } else {
      messageError = window.Vue.$t('errorMessages.no_connection');
    }
    window.Vue.$notify({
      title: 'Error',
      text: messageError,
      type: 'error',
      duration: 10000,
    });
  },
};
